<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            d="M10.5 3c.5523 0 1 .44772 1 1v2H7.6164l.70969-2.29539C8.45562 3.28568 8.84297 3 9.28147 3H10.5Zm-4.73869 9H11.5v7.931c0 .5523-.4477 1-1 1H4.35588c-.67337 0-1.15428-.652-.95538-1.2954L5.76131 12ZM18.25 12h-5.478l.2033 8.0253c.0137.5423.4573.9747.9997.9747h5.6738c.672 0 1.1527-.6496.9563-1.2922L18.25 12Zm-5.6301-6h3.7967l-.7004-2.29222C15.5877 3.28725 15.1996 3 14.7599 3h-1.1903c-.5622 0-1.0139.4633-.9997 1.02533L12.6199 6Z"
        />
        <path
            d="M1 8.80005c0-.55229.44772-1 1-1h20c.5523 0 1 .44771 1 1v.4c0 .55228-.4477.99995-1 .99995h-.216l.7985 2.4952C22.789 13.3405 22.3075 14 21.63 14h-.3c-.4349 0-.8199-.281-.9525-.6952l-.96-3c-.0111-.0349-.0203-.0699-.0275-.1048H4.93041c-.01076.0518-.02581.1037-.0454.1552l-1.13999 3c-.1475.3882-.51954.6448-.93479.6448h-.26047c-.70006 0-1.18345-.7008-.93478-1.3552l.929-2.4448H2c-.55228 0-1-.44767-1-.99995v-.4Z"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            d="M9.5 8V5h-.39965l-.76024 3H6.27689l1.0759-4.24565C7.46522 3.3107 7.86448 3 8.32215 3H10.5c.5523 0 1 .44772 1 1v4h-2Zm-2.17354 4-1.75642 6.931H9.5V12h2v7.931c0 .5523-.4477 1-1 1H4.28502c-.6519 0-1.1295-.6137-.96936-1.2456L5.26324 12h2.06322Zm7.34484-4-.0761-3h.3432l.75 3H17.75l-1.0607-4.24254C16.578 3.3123 16.1781 3 15.7192 3h-2.1496c-.5622 0-1.0139.4633-.9997 1.02533L12.6706 8h2.0007Zm.1013 4H12.772l.2033 8.0253c.0137.5423.4572.9747.9997.9747h5.7442c.6506 0 1.1279-.6114.9701-1.2425L18.75 12h-2.0616l1.75 7H14.95l-.1774-7Z"
        />
        <path
            d="M1 10c0-.55228.44772-1 1-1h20c.5523 0 1 .44772 1 1 0 .5523-.4477 1-1 1h-.6l.3654 1.8271c.1214.6068-.3427 1.1729-.9615 1.1729-.4674 0-.8699-.3299-.9615-.7883L19.4 11H4.60001l-.44235 2.2117c-.09167.4584-.49411.7883-.96154.7883-.61879 0-1.08289-.5661-.96153-1.1729L2.60001 11H2c-.55228 0-1-.4477-1-1Z"
        />
    </svg>
</template>
